import React from "react";
import about_img from "../assets/logo.webp";
import { Link } from "react-router-dom";

const AboutUs = () => {
  return (
    <div className="flex flex-col md:flex-row gap-2 md:h-[80vh] bg-pimary items-center justify-center p-4 md:px-12 md:py-4">
      {/* Image Section */}
      <div className="flex justify-center">
        <img
          src={about_img}
          alt="QUANTUMTECH 2027"
          loading="lazy"
          className="h-[50%] md:max-h-[60%] w-auto md:w-[35vh] md:mx-12 rounded-2xl object-cover"
        />
      </div>

      {/* Text Content */}
      <div className="flex flex-col w-full md:w-2/3">
        <h1 className="text-xl md:text-3xl font-bold my-2">
          <span className="text-one">CRUX: "Digital Transformation and </span>{" "}
          the Future of Humanity
        </h1>
        <p className="text-base my-2 text-justify">
          Impact of AI, Robotics, IoT, and Digital Technologies on society,
          ethics, and human evolution. Smart city infrastructure, urban
          planning, sustainable energy, mobility, and environmental tech.
          Data security, digital identity, privacy laws, and new cybersecurity
          technologies.{" "}
          <Link
            className="text-accent font-bold"
            target="_blank"
            // to="https://helixconferences.com/blog.php"
          ></Link>{" "}
        </p>

        <Link to="/about-Quantumtech-conclave">
          <button className="flex bg-one text-white px-6 md:px-8 py-2 my-4 rounded-full text-sm md:text-base">
            Know More
          </button>
        </Link>
      </div>
    </div>
  );
};

export default AboutUs;
